import { render, staticRenderFns } from "./producer_upload_image.vue?vue&type=template&id=176472fd&scoped=true"
import script from "./producer_upload_image.vue?vue&type=script&lang=js"
export * from "./producer_upload_image.vue?vue&type=script&lang=js"
import style0 from "./producer_upload_image.vue?vue&type=style&index=0&id=176472fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176472fd",
  null
  
)

export default component.exports